import { createRouter, createWebHashHistory } from "vue-router";
import UsedAuthIndex from "@/pages/AuthIndex.vue";
import UsedIMSIndex from "@/pages/Accounts/IMSPage.vue";
import UsedIWCIndex from "@/pages/Accounts/IWCPage.vue";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "login",
    component: UsedAuthIndex,
    meta: {
      main: "Login",
      title: "Login",
      subtitle: "",
      layout: "General",
      requiresAuth: false,
    },
  },
  {
    path: "/ims",
    name: "dashboard",
    component: UsedIMSIndex,
    meta: {
      main: "Dashboard",
      title: "IMS Accounts (Red)",
      layout: "Account",
      requiresAuth: true,
    },
  },
  {
    path: "/iwc",
    name: "iwc",
    component: UsedIWCIndex,
    meta: {
      main: "Dashboard",
      title: "IWC Accounts (Green)",
      layout: "Account",
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = `Payment Verification`;
  let isAuthenticate = store.state.isAuthorized;

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticate) {
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    if (to.name === "login" && isAuthenticate) {
      next({ path: "/ims" });
    } else {
      next();
    }
  }
});

export default router;
